import React from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';

class Atlas extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        proid: PropTypes.string,
        subid: PropTypes.string,
        _id: PropTypes.string,
        isVideoShare: PropTypes.bool,
        wxLaunch: PropTypes.object,
    };
    /**
     * 渲染网页布局
     */
    openAppLookFn = (url, id, newstype, index, isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        if (index !== 0) return '';
        const { proid } = this.props;
        const downloads = {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
        };

        // 打开app查看更多点击统计
        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'seepic',
                    other: {
                        ref: `ucms_${proid}`,
                        kind: 'pic',
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'seepic',
                    other: {
                        ref: `ucms_${proid}`,
                        kind: 'pic',
                        tag: 't9',
                    },
                },
            ]);
        }

        if (isCallApp) {
            this.handleClick(url, id, newstype, downloads, isJumpQQlink);
        }
    };
    handleClick = (url, id, newstype, downloads = {}, isJumpQQlink) => {
        const { subid, isVideoShare } = this.props;
        const doc_type = newstype;
        const subidVal = subid ? `&subid=${subid}` : '';
        const aid = id + subidVal;
        const client = isVideoShare ? 'videoApp' : 'newsApp';
        const downloadsVal = isVideoShare ? {} : downloads;

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            kind: 'share52210',
            download: downloadsVal.download,
            downloadAd: downloadsVal.download,
            isCopySchemeUrl: isJumpQQlink,
        });
    };

    /**
     * 插入 Cooperation html
     */
    createCooperation = (title) => {
        title = title.replace(/\n/g, '<br>');

        return { __html: title };
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content, proid, isVideoShare, wxLaunch, _id } = this.props;
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const wxLaunchType = wxLaunch.wxLaunchType;
        const schemeLink =
            wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'immersionslide',
                      pid: _id,
                  })
                : getSchemeLink({
                      docType: 'immersionslide',
                      pid: _id,
                      kind: 'share52210',
                  });
        const loadImgUrl =
            'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="349" height="196"><text x="120" y="108" fill="%23dcdcdc" style="font-size: 28px;">鳳凰新聞</text></svg>';
        const atlasItem = content.map((item, index) => (
            <section key={index} className={styles.atlas}>
                <div
                    className={styles.atlasBox}
                    onClick={this.openAppLookFn.bind(
                        this,
                        typeof window === 'object' ? location.href : '',
                        _id,
                        'immersionslide',
                        index,
                    )}>
                    <LazyImg
                        placeholder={loadImgUrl}
                        src={item.image}
                        className={styles.pic}
                        loadData="load success!!"
                    />
                    {index === 0 && (
                        <>
                            <div className={styles.callUpBox}>
                                {isVideoShare && (
                                    <div className={styles.callUpBoxTitle}>打开凤凰视频，查看更多高清图片</div>
                                )}
                                {!isVideoShare && (
                                    <div className={styles.callUpBoxTitle}>打开凤凰新闻，查看更多高清图片</div>
                                )}
                            </div>
                            {!isVideoShare && wxLaunchSwitch && (
                                <WxLaunchApp
                                    launchType={wxLaunchType}
                                    launchAppClick={this.openAppLookFn.bind(
                                        this,
                                        typeof window === 'object' ? location.href : '',
                                        _id,
                                        'immersionslide',
                                        index,
                                        true,
                                        false,
                                        false,
                                    )}
                                    schemeLink={schemeLink}
                                    launchAppFail={this.openAppLookFn.bind(
                                        this,
                                        typeof window === 'object' ? location.href : '',
                                        _id,
                                        'immersionslide',
                                        index,
                                        false,
                                        true,
                                        true,
                                    )}
                                />
                            )}
                        </>
                    )}
                </div>
                {item.title && (
                    <div className={styles.txt} dangerouslySetInnerHTML={this.createCooperation(item.title)} />
                )}
            </section>
        ));

        return atlasItem;
    }
}

export default Atlas;
